import { atom, selectorFamily } from 'recoil'

import {
  type ColumnName,
  type DynamicField,
  defaultColumns,
} from 'Pages/RecipientsList/model'

export const columnsState = atom<ColumnName[]>({
  key: 'recipientsList_columnsState',
  default: defaultColumns,
})

export const dynamicFieldsState = atom<DynamicField[]>({
  key: 'recipientsList_dynamicFieldsState',
  default: [],
})

export const dynamicFieldSelector = selectorFamily<
  DynamicField | undefined,
  number
>({
  key: 'recipientsList_dynamicFieldSelector',
  get:
    (idField) =>
    ({ get }) => {
      const fields = get(dynamicFieldsState)

      const f = fields.find((f) => f.id === idField)

      return f
    },
})
